// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__gS9Px","createdSearch":"index_createdSearch__aziDF","custom_table":"index_custom_table__pKnV5"};